import { makeStyles } from "@material-ui/core/styles";
export default makeStyles(() => ({
  searchBar: {
    color: "#c7c7c9",
  },
}));
